export default __webpack_public_path__ + "static/media/ic_people_outline_blue_48px.87a413fd.svg";